module.exports = __webpack_public_path__ + "static/img/緊急通知_300×300.1280b6ca.png";